import {AxiosInstance} from 'axios'

import {mapShiftEvent} from '../mappers'
import {EventCreate, ShiftEvent, ShiftEventDto} from '../types'
import {getEventBackendEndpoint} from '../utils/endpoints'
import {prepareEventFormData} from '../utils/formData'

export const createEvent = async (
  axiosInstance: AxiosInstance,
  plantId: string,
  event: EventCreate,
  timezone: string,
  scheduleRecurringTask: boolean | undefined = false
): Promise<ShiftEvent> => {
  const formData = await prepareEventFormData(event)
  const path = getEventBackendEndpoint(plantId, event.eventType, scheduleRecurringTask)

  const response = await axiosInstance.post<ShiftEventDto>(path, formData)
  return mapShiftEvent(response.data, timezone)
}
